import { Component, Input, Output, EventEmitter } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { AppIconComponent } from '../../../../common/components/icon/icon.component';
import { QuoteSummaryDto } from '../../../../core/data/dtos/quote-summary.dto';

export type PaymentAmountOption = 'total' | 'minimum' | 'other';

@Component({
  selector: 'app-checkout-payment',
  standalone: true,
  imports: [CommonModule, FormsModule, AppIconComponent],
  templateUrl: './checkout-payment.component.html',
  styleUrls: ['./checkout-payment.component.scss'],
})
export class CheckoutPaymentComponent {
  @Input() summary: QuoteSummaryDto | null = null;
  @Input() quoteCurrency: string = 'RD$';
  @Input() minimumPaymentAmount: number = 0;

  // Two-way binding for paymentAmountOption
  @Input() paymentAmountOption: PaymentAmountOption = 'total';
  @Output() paymentAmountOptionChange = new EventEmitter<PaymentAmountOption>();

  // Two-way binding for paymentOtherAmount
  @Input() paymentOtherAmount: string = '';
  @Output() paymentOtherAmountChange = new EventEmitter<string>();

  @Input() isPaymentAmountInvalid: boolean = false;


  // Two-way binding for termsAccepted
  @Input() termsAccepted: boolean = false;
  @Output() termsAcceptedChange = new EventEmitter<boolean>();

  showTermsModal: boolean = false;

  get paymentTotalAmount(): number {
    return this.summary?.totalGrossPremium ?? 0;
  }

  get isPaymentOtherAmountInvalid(): boolean {
    const parsed = parseFloat(this.paymentOtherAmount);
    // Invalid if parsed is greater than total, OR if it's less than the minimum payment amount
    return !isNaN(parsed) && (parsed > this.paymentTotalAmount || parsed < this.minimumPaymentAmount);
  }

  get paymentErrorType(): 'max' | 'min' | null {
    const parsed = parseFloat(this.paymentOtherAmount);
    if (isNaN(parsed)) return null;
    if (parsed > this.paymentTotalAmount) return 'max';
    if (parsed < this.minimumPaymentAmount) return 'min';
    return null;
  }

  setOption(option: PaymentAmountOption): void {
    if (option === 'other') {
      this.paymentOtherAmount = this.minimumPaymentAmount.toFixed(2);
      this.paymentOtherAmountChange.emit(this.paymentOtherAmount);
    }
    this.paymentAmountOption = option;
    this.paymentAmountOptionChange.emit(option);
  }


  openTermsModal(event: Event): void {
    event.preventDefault(); // Prevent default link behavior
    this.showTermsModal = true;
  }

  closeTermsModal(): void {
    this.showTermsModal = false;
  }
}
